<template>
  <div id="app_wallet">
    <transition :name="direction">
      <!-- <keep-alive> -->
        <router-view />
      <!-- </keep-alive> -->
    </transition>
  </div>
</template>

<script>
export default {
  name: 'wallet-index',
  data () {
    return {
      direction: 'view-forward'
    }
  },
  methods: {

  },
  mounted () {},
  watch: {
    '$route' (to, from) {
      const toDepth = to.path.split('/').length
      const fromDepth = from.path.split('/').length
      this.direction = toDepth < fromDepth ? 'view-back' : 'view-forward'
    }
  }
}
</script>
